// ATTENTION: Since we only have one language in this app, add your new translations directly in en.js.
export default {}
